import { validators } from '../../utils/validators';
import { ERROR_MESSAGES, SETTLEMENT_TYPES } from './constants';

const validate =(values) => {

    const { REQUIRED, MAX_LENGTH, POSITIVE_NUMBER, ALPHA_NUMERIC, IS_VALID_IFSC } = validators;
    const errors = {
        narrationConfig: {
            suffix: {},
            prefix: {},
            interim: {},
            secondInterim: {},
        },
    };

    const accountErrors = [];

    if (
        values &&
        values.accountDetails &&
        values.accountDetails.length
    ) {
        values.accountDetails.forEach((account, accountIndex) => {
            const accountError = {};
            // console.log(account, "account" );
            if (REQUIRED(account.accountOwnership)) {
                accountError.accountOwnership = 'Please select Account Ownership';
            }

            if (REQUIRED(account.accountNumber)) {
                accountError.accountNumber = 'Please enter Account Number';
            }

            if (account.accountNumber) {
                accountError.accountNumber = MAX_LENGTH(account.accountNumber, 18);
            }

            if (REQUIRED(account.ifscCode)) {
                accountError.ifscCode = 'Please enter IFSC code';
            }

            if (account.ifscCode) {
                
                accountError.ifscCode = MAX_LENGTH(account.ifscCode, 11);
                if(!accountError.ifscCode){
                    accountError.ifscCode = IS_VALID_IFSC(account.ifscCode)
                }
                
            
            }
            
            if (REQUIRED(account.bankName)) {
                accountError.bankName = 'Please enter Bank Name';
            }

            if (REQUIRED(account.accountHolderName)) {
                accountError.accountHolderName = 'Please enter Account Holder Name';
            }

            if (Object.keys(accountError).length) {
                accountErrors[accountIndex] = accountError;
            }
        });
    }

    errors.accountDetails = accountErrors;

    const ediErrors = [];

    if (
        values &&
        values.ediConfInfoList &&
        values.ediConfInfoList.length
    ) {
        values.ediConfInfoList.forEach((edi, ediIdx) => {
            const ediError = {};

            if (REQUIRED(edi.debitType)) {
                ediError.debitType = 'Please select Debit Type';
            }

            if (REQUIRED(edi.debitFrequency)) {
                ediError.debitFrequency = 'Please enter Debit Frequency';
            }

            if (REQUIRED(edi.settlementFrequency)) {
                ediError.settlementFrequency = 'Please enter Settlement Frequency';
            }

            if (REQUIRED(edi.flatAmount)) {
                ediError.flatAmount = 'Please enter Flat Amount';
            }

            if (REQUIRED(edi.startDate)) {
                ediError.startDate = 'Please enter start date';
            }

            // if (REQUIRED(edi.endDate)) {
            //     ediError.endDate = 'Please enter End Date';
            // }

            if (REQUIRED(edi.monthlyDebitDate)) {
                ediError.monthlyDebitDate = 'Please enter Monthly Debit Date';
            }

            if (REQUIRED(edi.debitAmountPer)) {
                ediError.debitAmountPer = 'Please enter Debit Amount';
            }

            if (REQUIRED(edi.feeType)) {
                ediError.feeType = 'Please enter Fee Type';
            }

            if (REQUIRED(edi.settlementAmount)) {
                ediError.settlementAmount = 'Please enter Settlement Amount';
            }

            if (REQUIRED(edi.accountNumber)) {
                ediError.accountNumber = 'Please enter Account Number';
            }

            if (REQUIRED(edi.settlementAmountType)) {
                ediError.settlementAmountType = 'Please enter Settlement Amount Type';
            }

            if (edi.totalAmount && edi.debitAmountPer && (Number(edi.totalAmount) < Number(edi.debitAmountPer))) {
                ediError.totalAmount = 'Total amount should be greater than the Debit Amount.';
            }

            if (Object.keys(ediError).length) {
                ediErrors[ediIdx] = ediError;
            }
        });
    }

    errors.ediConfInfoList = ediErrors;

    if (REQUIRED(values.sameDaySettlementCharge)) {
        errors.sameDaySettlementCharge = 'Please Select Fee base';
    }

    if (
        values.refundWithNegativeBalanceFlag &&
        REQUIRED(values.refundThreshold)
    ) {
        errors.refundThreshold = 'Please enter refund amount';
    }

    if (values.refundThreshold) {
        errors.refundThreshold = POSITIVE_NUMBER(values.refundThreshold);
    }

    if (values.hierarchyCommission && !values.hierarchyCommissionList) {
        errors.hierarchyCommissionList = 'Please select hierarchy commission';
    }

    if (
        values.hierarchyCommission &&
        values.hierarchyCommissionList &&
        values.hierarchyCommissionList.length <= 0
    ) {
        errors.hierarchyCommissionList = 'Please select hierarchy commission';
    }

    if (REQUIRED(values.disbursementCycle)) {
        errors.disbursementCycle = 'Please enter Disbursement Cycle';
    }
    if (REQUIRED(values.disbursementTriggerSlot)) {
        errors.disbursementTriggerSlot =
            'Please select Disbursement Trigger Slot';
    }
    if (REQUIRED(values.disbursementInterval)) {
        errors.disbursementInterval = 'Please select Disbursement Interval';
    }
    if (REQUIRED(values.settlementType)) {
        errors.settlementType = 'Please enter Settlement Type';
    }
    if (REQUIRED(values.settlementParty)) {
        errors.settlementParty = 'Please enter Settlement Party';
    }
    if (REQUIRED(values.fcCommissionType)) {
        errors.fcCommissionType = 'Please Select fee type';
    }

    if (REQUIRED(values.fundTransferType)) {
        errors.fundTransferType = 'Please Select Settlement Channel';
    }
    if (values?.sameDaySettlement?.includes(SETTLEMENT_TYPES.ODS)) {
        // Ensure the nested structure exists
        errors.odsConfigInfo = errors.odsConfigInfo || {};
      
        if (REQUIRED(values?.odsConfigInfo?.minOdsAmount)) {
          errors.odsConfigInfo.minOdsAmount = ERROR_MESSAGES.MIN_ODS_AMOUNT;
        }
      
        if (REQUIRED(values?.odsConfigInfo?.numberOfOdsInDay)) {
          errors.odsConfigInfo.numberOfOdsInDay = ERROR_MESSAGES.NUMBER_OF_ODS;
        }
      
        if (REQUIRED(values?.odsConfigInfo?.coolingPeriod)) {
          errors.odsConfigInfo.coolingPeriod = ERROR_MESSAGES.COOLING_PERIOD;
        }
      }



    // if(values.fcCommissionType === "SURCHARGE" && values.settlementType === "NET" && values.nextSettlementType === "GROSS"){
    //     errors.fcCommissionType = "Kindly change your fee type to MDR to enable gross settlement as a next settlement type";
    // }

    // if(REQUIRED(values.sameDaySettlement)){
    //     errors.sameDaySettlement = "Please select same day settlement";
    // }

  if (values.sameDaySettlement && values.odsFeeCriteria) {
      if (values.odsFeeCriteria === "FEE_PERCENT") {
          if (values.feePercent < 0 || values.feePercent > 100) {
              errors.feePercent = "Fee percent must be between 0 and 100.";
          } else if (!values.feePercent) {
              errors.feePercent = "Please enter fee percent";
          }
      } else if (values.odsFeeCriteria === "FEE_FLAT") {
          if (values.flatFee < 0) {
              errors.flatFee = "Flat fee cannot be less than 0.";
          } else if (!values.flatFee) {
              errors.flatFee = "Please enter flat fee";
          }
      }
  } else if (values.sameDaySettlement && !values.odsFeeCriteria) {
      errors.odsFeeCriteria = "Please select fee criteria";
  }

    if (
        values.narrationConfig &&
        values.narrationConfig.prefix &&
        values.narrationConfig.prefix.prefixType &&
        values.narrationConfig.prefix.prefixType === 'CUSTOM' &&
        !values.narrationConfig.prefix.customPrefixIdentifier
    ) {
        errors['narrationConfig']['prefix'].customPrefixIdentifier =
            'Please enter custom prefix';
    }

    if (
        values.narrationConfig &&
        values.narrationConfig.prefix &&
        values.narrationConfig.prefix.prefixType &&
        values.narrationConfig.prefix.prefixType === 'CUSTOM' &&
        values.narrationConfig.prefix.customPrefixIdentifier
    ) {
        errors['narrationConfig'][
            'prefix'
        ].customPrefixIdentifier = ALPHA_NUMERIC(
            values.narrationConfig.prefix.customPrefixIdentifier
        );
    }

    if (
        values.narrationConfig &&
        values.narrationConfig.suffix &&
        values.narrationConfig.suffix.suffixType &&
        values.narrationConfig.suffix.suffixType === 'CUSTOM' &&
        !values.narrationConfig.suffix.customSuffixIdentifier
    ) {
        errors['narrationConfig']['suffix'].customSuffixIdentifier =
            'Please enter custom suffix';
    }

    if (
        values.narrationConfig &&
        values.narrationConfig.suffix &&
        values.narrationConfig.suffix.suffixType &&
        values.narrationConfig.suffix.suffixType === 'CUSTOM' &&
        values.narrationConfig.suffix.customSuffixIdentifier
    ) {
        errors['narrationConfig'][
            'suffix'
        ].customSuffixIdentifier = ALPHA_NUMERIC(
            values.narrationConfig.suffix.customSuffixIdentifier
        );
    }

    if (
        !values.instantSettlement &&
        values.narrationConfig &&
        values.narrationConfig.interim &&
        values.narrationConfig.interim.interimType &&
        values.narrationConfig.interim.interimType !== 'PAYABLE_ID' &&
        values.narrationConfig.interim.interimType !== 'BLANK'
    ) {
        errors['narrationConfig']['interim'].interimType =
            'For cyclic settlement, only payable ID can be selected.';
    }

    if (
        !values.instantSettlement &&
        values.narrationConfig &&
        values.narrationConfig.secondInterim &&
        values.narrationConfig.secondInterim.interimType &&
        values.narrationConfig.secondInterim.interimType !== 'BLANK'
    ) {
        errors['narrationConfig']['secondInterim'].interimType =
            'Invalid Selection, second Interim is not possible for cyclic settlement.';
    }

    return errors;
};

export const validateReports = (data, type) => {
    let isValid = true;
    let message = "";

    if (data.some(item => item.name.trim() === '')) {
        isValid = false;
        message = "Please fill the report name!";
    } else if (!data.some(item => item.isEnable === true)) {
        isValid = false;
        message = `Please select atleast one ${type} Report Header.`;
    }

    return { isValid, message };
}


export default validate;
